window.addEventListener("load", (event) => {
  // Elements
  const tmst = document.querySelector("[data-tmst]"),
    tmstToggle = tmst.querySelector("[data-tmst-toggle]"),
    tmstCustomizeTheme = tmst.querySelector("[data-customize-theme]"),
    tmstCurrentUrl = tmst.querySelector("[data-current-url]"),
    tmstClose = tmst.querySelector("[data-tmst-close]"),
    tmstPreviewBar = document.getElementById("PBarNextFrameWrapper"),
    tmstPreviewBarToggle = document.querySelector("[data-preview-bar-toggle]"),
    tmstUrlCopyAnchors = document.querySelectorAll("[data-url-copy]");

  // General toggle
  (function () {
    if (!tmst || !tmstToggle) return;
    let tmstActive = false;

    tmstToggle.addEventListener("click", (e) => {
      if ((tmstCustomizeTheme && e.ctrlKey) || e.metaKey) {
        let customizeUrl = tmstCustomizeTheme.getAttribute("href");
        window.open(customizeUrl, "_blank").focus();
        return;
      }

      if (e.shiftKey) {
        let currentUrl = tmstCurrentUrl.getAttribute("data-url");
        if (currentUrl) navigator.clipboard.writeText(currentUrl);
        return;
      }

      if (tmstActive) {
        tmst.classList.remove("tmst--active");
        tmstActive = false;
      } else {
        tmst.classList.add("tmst--active");
        tmstActive = true;
      }
    });

    window.addEventListener("click", (event) => {
      if (tmstActive && event.target.closest(".tmst") == null) {
        tmst.classList.remove("tmst--active");
        tmstActive = false;
      }
    });
  })();

  // Close
  (function () {
    if (!tmst || !tmstClose) return;
    tmstClose.addEventListener("click", () => {
      tmst.remove();
    });
  })();

  // Toggle Shopify's native preview bar
  (function () {
    if (
      window.location.href.includes("127.0.0.1:9292") &&
      tmstPreviewBarToggle
    ) {
      tmstPreviewBarToggle.remove();
    }

    if (!tmstPreviewBarToggle) return;

    if (tmstPreviewBar) tmstPreviewBarToggle.textContent = "Hide preview bar";

    //Toggles preview bar using official query string method
    //https://shopifypartners.slack.com/archives/C4E704GBX/p1744733267580299
    tmstPreviewBarToggle.addEventListener("click", () => {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('pb', tmstPreviewBar ? 0 : 1);
      window.location.href = currentUrl.href;
    });
  })();

  // Update Copy and Go buttons on theme selection
  (function () {
    if (!tmstUrlCopyAnchors) return;
    tmstUrlCopyAnchors.forEach((anchor) => {
      anchor.addEventListener("click", () => {
        let dataUrl = anchor.getAttribute("data-url");
        if (dataUrl) navigator.clipboard.writeText(dataUrl);
      });
    });
  })();
});
